import { render, staticRenderFns } from "./ImageUploadForm.vue?vue&type=template&id=3d643ddc&scoped=true&"
import script from "./ImageUploadForm.vue?vue&type=script&lang=js&"
export * from "./ImageUploadForm.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploadForm.vue?vue&type=style&index=0&id=3d643ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d643ddc",
  null
  
)

export default component.exports